import React from 'react';
import styled, { css } from 'styled-components';
import { FlexContainer } from 'base-components';
import { object, bool, string } from 'prop-types';
import { map, size } from 'lodash';
import { Text, Loading } from 'app-components/common';
import ConditionalRender from 'app-components/shared/ConditionalRender';
import { genUUID } from 'app-utils/misc';
import { urlSisa, urlBase } from './../../../../components/utils/changeUrlSisa';
import SelectIcon from './SelectIcon';

let color = '#4cb358';

if (urlSisa() === urlBase()) color = '#4daea9';

const OptionsWrapper = styled.ul`
    position: ${({ position }) => position || 'absolute'};
    width: 100%;
    top: ${({ optionsUp }) => optionsUp ? '-200%' : '110%'};
    z-index: 1000;
    max-height: 200px;
    border-radius: inherit;
    border: 1px solid rgba(0,0,0,0.17);
    box-shadow: 0 0 5px rgba(0,0,0,0.1);
    transition: all 0.5s ease-in;
    list-style: none;
    background: white;
    padding: 0px;
    overflow-y: auto;
    overflow-x: none;
    margin: 0px;
`;

const OptionItem = styled.li`
    padding: 5px;
    ${({ align }) => align && css`text-align: center`};
    cursor: ${({ disabled = false }) => disabled ? 'not-allowed' : 'pointer'};
    &:hover {
        background-color: #f4f4f4;
    }

    &:last-child {
        border: 0px;
    }
`;

const OptionItemList = ({ value, isSelected }) => {
    return (
        <FlexContainer>
            <Text truncate renderAs='div' text={String(value)} style={isSelected ? { color } : {}} />
            <ConditionalRender condition={isSelected}>
                <SelectIcon justify='center'>
                    <span className='icon-ic-check' style={{ fontSize: '12px', color }} />
                </SelectIcon>
            </ConditionalRender>
        </FlexContainer>
    );
};

OptionItemList.propTypes = {
    value: string,
    isSelected: bool
};

const SelectOptions = ({ optionsUp, placeholderAllSelected, position, context: SelectContext, fromUserSelect }) => {
    return (
        <SelectContext.Consumer>
            {({ options, onSelect, isSelected, isMultiple, autoComplete, toggleSelectAll, allSelected, activateOptionAll, loadingFilterUser, filterBy }) => {
                if (size(filterBy) < 3 && fromUserSelect) return null;

                return <OptionsWrapper position={position} optionsUp={optionsUp}>
                    <ConditionalRender condition={(isMultiple || activateOptionAll) && size(options) > 0 && !fromUserSelect}>
                        <OptionItem key='select-(1)-select-all' onClick={(e) => { e.stopPropagation(); toggleSelectAll(allSelected); }}>
                            <OptionItemList value={placeholderAllSelected || 'Todos'} isSelected={allSelected} />
                        </OptionItem>
                    </ConditionalRender>
                    <ConditionalRender condition={autoComplete && !(size(options) > 0 && options !== null) && (!loadingFilterUser && size(filterBy) >= 3)}>
                        <OptionItem key='select-(2)-not-found' disabled>
                            <OptionItemList value='No encontrado' />
                        </OptionItem>
                    </ConditionalRender>
                    <ConditionalRender condition={loadingFilterUser}>
                        <OptionItem key='select-(3)-loading' disabled align='center'>
                            <Loading loading />
                        </OptionItem>
                    </ConditionalRender>
                    { map(options, ({ value, label }, index) =>
                        <OptionItem key={index} onClick={(e) => { e.stopPropagation(); onSelect({ value, label }); }}>
                            <OptionItemList key={genUUID()} value={label} isSelected={isSelected(value)} />
                        </OptionItem>
                    )}
                </OptionsWrapper>;
}}
        </SelectContext.Consumer>
    );
  };

SelectOptions.propTypes = {
    optionsUp: bool,
    position: object,
    placeholderAllSelected: bool,
    context: object,
    fromUserSelect: bool
};

export default SelectOptions;
